// @flow
export const FETCH_CHARACTER_REQUEST = 'FETCH_CHARACTER_REQUEST';
export const FETCH_CHARACTER_SUCCESS = 'FETCH_CHARACTER_SUCCESS';
export const FETCH_CHARACTER_FAILURE = 'FETCH_CHARACTER_FAILURE';

export const FETCH_ACHIEVEMENTS_REQUEST = 'FETCH_ACHIEVEMENTS_REQUEST';
export const FETCH_ACHIEVEMENTS_SUCCESS = 'FETCH_ACHIEVEMENTS_SUCCESS';
export const FETCH_ACHIEVEMENTS_FAILURE = 'FETCH_ACHIEVEMENTS_FAILURE';

export const FETCH_REALMS_REQUEST = 'FETCH_REALMS_REQUEST';
export const FETCH_REALMS_SUCCESS = 'FETCH_REALMS_SUCCESS';
export const FETCH_REALMS_FAILURE = 'FETCH_REALMS_FAILURE';

export const SET_CHARACTER_URL = 'SET_CHARACTER_URL';
export const SET_REGION = 'SET_REGION';
export const HYDRATE_ACHIEVEMENTS = 'HYDRATE_ACHIEVEMENTS';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const SET_FILTER = 'SET_FILTER';
export const RESET_FILTER = 'RESET_FILTER';
export const SET_SORTING = 'SET_SORTING';
export const SET_VIEW_TYPE = 'SET_VIEW_TYPE';
export const RESET_CHARACTER = 'RESET_CHARACTER';



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js